import React from "react";
import useExpanderTable from "../expander-table/hooks"
import ArrowUpward from "@material-ui/icons/ArrowUpward"
import clsx from 'clsx';
import './styles.css'

const ExpanderTableHeader = ({className="", component, children}) => {
    const [state, setState] = useExpanderTable();

    if (!state) {
        console.warn("ExpanderTableHeader must be a descendant of ExpanderTable")
        return null;
    }

    const handleHeaderClick = (column='') => {
        if (column === '') { return }

        let sorting = {column: column, direction: 'desc'}

        // If we're already sorted by that column, reverse direction
        if (state.sorting.column === sorting.column) {
            sorting.direction = state.sorting.direction === 'asc' ? 'desc' : 'asc';
        }
        setState({...state, sorting})
    }

    // Generate the render content

    // Get the columns defs from the table state
    const columnDefs = state.columns || [];

    // Get the header renderer
    const renderer = component || TableHeader;

    // If the user has specified another component, use that...

    // Default to displaying just the child elements children if there's no columns defs
    // let content = children;
    // Create headers for each defined column
    // if (columnDefs.length > 0) {
    //     content = <TableHeader columnDefs={columnDefs} columnClickHandler={handleHeaderClick} sorting={state.sorting}/>
        // content = <>
        //     {columnDefs.map((col) => (
        //         <ColumnHeader
        //             key={ col.field || col.id }
        //             col={col}
        //             clickHandler={handleHeaderClick}
        //             sorting={state.sorting}
        //         />
        //     ))}
        //     {children}
        //     </>
    // }

    return (
        <div className={clsx(className, "flex flex-grow items-center border-b bg-white rounded-t shadow")}>
            {renderer({columnDefs: columnDefs, columnClickHandler: handleHeaderClick, sorting: state.sorting})}
            {children}
        </div>
    )
}

const TableHeader = ({columnDefs=[], columnClickHandler, sorting}) => {
    return (
        <>
            {columnDefs.map((col) => (
                <ColumnHeader
                    key={ col.field || col.id }
                    col={col}
                    clickHandler={columnClickHandler}
                    sorting={sorting}
                />
            ))}
        </>
    )
}

export const ColumnHeader = ({col, sorting={},  clickHandler, children}) => {

    let buttonStyle = '';
    if (clickHandler && col.field) {
        buttonStyle = 'cursor-pointer align-center';
    }

    let iconStyle = 'expander-table-header-icon '
    const {column, direction} = sorting
    if (column && direction && column === col.field) {
        if (direction === 'asc') {
            iconStyle += 'expander-table-header-arrow-up'
        } else if (direction === 'desc') {
            iconStyle += 'expander-table-header-arrow-down'
        }
    } else {
        iconStyle += 'expander-table-header-arrow-none'
    }

    return (
        <div id={col.field}  className={clsx(col.style, buttonStyle)} onClick={() => clickHandler(col.field)}>
            <div className="flex items-center">
                {children || col.title} <ArrowUpward className={iconStyle} />
            </div>
        </div>
    )
}

export default ExpanderTableHeader